import { ACTIONS, AMPLITUDE } from 'tracker.constants';

function eventBoilerplate(event, properties) {
  return { event, properties };
}

function amplitudeMutationRating(state, { type, data }) {
  return eventBoilerplate(AMPLITUDE[type], data);
}

export default {
  [ACTIONS.CREATE_MUTATION_RATING]: amplitudeMutationRating,
  [ACTIONS.CREATE_MUTATION_RATING_NOTES]: amplitudeMutationRating,

  [ACTIONS.OPENED_TRACKER]: (state, { data }) => {
    return eventBoilerplate(AMPLITUDE.OPENED_TRACKER, data);
  },

  [ACTIONS.OPENED_RATING]: () => {
    return eventBoilerplate(AMPLITUDE.OPENED_RATING);
  },

  [ACTIONS.OPENED_DISPLAY_RATING]: () => {
    return eventBoilerplate(AMPLITUDE.OPENED_DISPLAY_RATING);
  },

  [ACTIONS.OPENED_NOTES_RATING]: () => {
    return eventBoilerplate(AMPLITUDE.OPENED_NOTES_RATING);
  },

  [ACTIONS.CANCEL_NOTES_RATING]: () => {
    return eventBoilerplate(AMPLITUDE.CANCEL_NOTES_RATING);
  },

  [ACTIONS.OPENED_NOTES_RATING_CONFIRMATION]: () => {
    return eventBoilerplate(AMPLITUDE.OPENED_NOTES_RATING_CONFIRMATION);
  },

  [ACTIONS.OPENED_RECEIPTS]: () => {
    return eventBoilerplate(AMPLITUDE.OPENED_RECEIPTS);
  }
};
